import React, { useEffect, useState } from 'react';
import Common from '../../../Components/Layouts/Common';

import { fetchCityList } from '../../../Utils/cityProfileUtils';
import useApi from '../../../Hooks/useApi';
import DropDown from '../../../Components/UI/Inputs/DropDown';

import { overviewSectionConfig, indicatorsSectionConfig, infrastructureSectionConfig, InstitutionalCapacitySectionConfig } from './Components/sectionConfigs';
import DynamicSectionForm from './Components/DynamicSectionForm';
import SDGUploadSection from './SDGUploadSection';

function BasicDataInsertion() {
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [cityList, setCityList] = useState([]);
    const { request, error } = useApi();
    const [activeTab, setActiveTab] = useState('overview');


    const tabs = [
        { 
            key: 'overview', 
            title: 'Overview', 
            Component: DynamicSectionForm, 
            props: { section: overviewSectionConfig, column: 4 } 
        },
        { 
            key: 'infrastructure', 
            title: 'Infrastructure', 
            Component: DynamicSectionForm, 
            props: {  section: infrastructureSectionConfig, column: 4 }
        },
        { 
            key: 'institutional_capacity', 
            title: 'Institutional Capacity', 
            Component: DynamicSectionForm, 
            props: {  section: InstitutionalCapacitySectionConfig, column: 5 }
        },
        { 
            key: 'indicators', 
            title: 'Indicators', 
            Component: DynamicSectionForm, 
            props: {  section: indicatorsSectionConfig, column: 3 }
        },
        { 
            key: 'SDG', 
            title: 'Upload Shit Flow Diagram (SDG)', 
            Component: SDGUploadSection, 
            props: {} // No 'sections' config needed here
        },
   
    ];



    useEffect(() => {
        const fetchCityData = async () => {
            await fetchCityList(request, setCityList);
        };
        fetchCityData();
    }, []);

    return (
        <Common headline="Basic & Indicators Data Insertion">
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 p-8 font-inter text-gray-800">
                <div className="max-w-6xl mx-auto">
                    <div className="bg-white gap-2 p-6 rounded-lg shadow-lg mb-8 flex flex-col md:flex-row justify-around items-center space-y-4 md:space-y-0 md:space-x-6 border border-blue-100">
                        <div className="flex-1 w-full">
                            <DropDown
                                setter={(value) => {
                                    setSelectedCity(value);
                                }}
                                label="Select City"
                                placeholder="Select City"
                                value={selectedCity}
                                options={cityList?.map((city) => ({
                                    ...city,
                                    name: city?.name,
                                    value: city?.id,
                                }))}
                                baggage={true}
                            />
                        </div>
                        <div className="flex-1 w-full" style={{ marginTop: '0' }}>
                            <DropDown
                                setter={(value) => {
                                    setSelectedYear(value);
                                }}
                                label="Select Year"
                                placeholder="Select Year"
                                value={selectedYear}
                                options={Array.from({ length: 2035 - 2018 + 1 }, (_, i) => {
                                    const year = 2018 + i;
                                    return {
                                        name: year.toString(),
                                        value: year,
                                    };
                                })}
                                baggage={true}
                            />

                        </div>
                    </div>



                    {selectedCity && selectedYear && (
                        <>
                            <div className="flex space-x-4 mb-6">
                                {tabs.map(tab => (
                                    <button
                                        key={tab.key}
                                        className={`px-4 py-2 rounded-t-lg font-medium border-b-2 ${activeTab === tab.key
                                            ? 'border-blue-500 text-blue-700 bg-white'
                                            : 'border-transparent text-gray-500 hover:text-blue-500 hover:border-blue-300'
                                            }`}
                                        onClick={() => setActiveTab(tab.key)}
                                    >
                                        {tab.title}
                                    </button>
                                ))}
                            </div>
<div className="mt-4">
                                {tabs.map(tab => {
                                    if (activeTab !== tab.key) return null;

                                    const { Component, props: tabProps } = tab;

                                    return (
                                        <Component
                                            key={tab.key}
                                            section={tab.key}
                                            title={tab.title}
                                            sections={tabProps.section}
                                            city={selectedCity.id}
                                            year={selectedYear.name}
                                            column={tabProps.column}
                                            onSubmitSuccess={() => {
                                                const currentIndex = tabs.findIndex(t => t.key === tab.key);
                                                const nextTab = tabs[currentIndex + 1];
                                                if (nextTab) setActiveTab(nextTab.key);
                                            }}
                                   
                                           
                                        />
                                    );
                                })}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Common>
    );
}

export default BasicDataInsertion;
